import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { MarketplaceAppPaymentModel } from '@atlassian/mpac-types/graphql-gateway-types';
import React from 'react';
import { FREE_APP_CTA_LABEL_SECONDARY } from '../../../../constants';
import { CTAKind, PurchaseIntent } from '../../AppListing.types';
import { ArtifactDownloadButton, getArtifactOrLearnMoreCTAs, LicensePurchaseForm, TrialLicenseForm, UnsupportedPrimaryCTA } from '../AppListingCTACollection';
import { jsx as _jsx } from "react/jsx-runtime";
function getFreeAppCTAs(ctaProps) {
  return {
    PrimaryCTA(ctaOverrides) {
      return /*#__PURE__*/_jsx(ArtifactDownloadButton, _objectSpread({
        appId: ctaProps.appId,
        buildNumber: ctaProps.appVersion.buildNumber,
        artifactDownloadLink: ctaProps.artifactDownloadLink,
        autoFocus: ctaProps.autoFocus,
        onClick: e => ctaProps.onClick(e, PurchaseIntent.GET, CTAKind.PRIMARY),
        ctaSubtext: FREE_APP_CTA_LABEL_SECONDARY
      }, ctaOverrides));
    },
    SecondaryCTA() {
      return null;
    }
  };
}
function getPaidViaAtlassianAppCTAs(ctaProps) {
  return {
    PrimaryCTA(ctaOverrides) {
      return /*#__PURE__*/_jsx(TrialLicenseForm, _objectSpread({
        appKey: ctaProps.appKey,
        appId: ctaProps.appId,
        buildNumber: ctaProps.appVersion.buildNumber,
        trialLicenseActivationLink: ctaProps.trialLicenseActivationLink,
        artifactDownloadLink: ctaProps.artifactDownloadLink,
        onClick: e => ctaProps.onClick(e, PurchaseIntent.TRY, CTAKind.PRIMARY),
        autoFocus: ctaProps.autoFocus,
        hosting: ctaProps.hosting
      }, ctaOverrides));
    },
    SecondaryCTA(ctaOverrides) {
      return /*#__PURE__*/_jsx(LicensePurchaseForm, _objectSpread({
        appKey: ctaProps.appKey,
        appId: ctaProps.appId,
        buildNumber: ctaProps.appVersion.buildNumber,
        licensePurchaseLink: ctaProps.licensePurchaseLink,
        artifactDownloadLink: ctaProps.artifactDownloadLink,
        autoFocus: ctaProps.autoFocus,
        onClick: e => ctaProps.onClick(e, PurchaseIntent.BUY, CTAKind.SECONDARY),
        hosting: ctaProps.hosting
      }, ctaOverrides));
    }
  };
}
export function getServerDCCTAs(_ref) {
  let {
    appId,
    appKey,
    onClick,
    appVersion,
    artifactDownloadLink,
    trialLicenseActivationLink,
    licensePurchaseLink,
    hosting,
    autoFocus
  } = _ref;
  switch (appVersion.paymentModel) {
    case MarketplaceAppPaymentModel.Free:
      return getFreeAppCTAs({
        appId,
        onClick,
        appVersion,
        artifactDownloadLink,
        autoFocus
      });
    case MarketplaceAppPaymentModel.PaidViaAtlassian:
      return getPaidViaAtlassianAppCTAs({
        appKey,
        appId,
        onClick,
        appVersion,
        trialLicenseActivationLink,
        artifactDownloadLink,
        licensePurchaseLink,
        hosting,
        autoFocus
      });
    case MarketplaceAppPaymentModel.PaidViaPartner:
      return getArtifactOrLearnMoreCTAs({
        binaryAvailable: true,
        appId,
        onClick,
        appVersion,
        artifactDownloadLink,
        autoFocus
      });
    default:
      return {
        PrimaryCTA: UnsupportedPrimaryCTA
      };
  }
}